import { withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';

const LocalBackdrop = withStyles({
  root: {
    position: 'absolute',
    zIndex: 1,
  },
})(Backdrop);

export default LocalBackdrop;
